import React, { Component } from 'react';
import { Select, Spin, Empty, DatePicker, InputNumber, Input, Modal, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
// import { excludesTableStore, excludesUpdateTableStore } from './../../selectStore';
import Select2 from '../select2/index';
import InputNumberlayer from '../InputNumberlayer';
import Datepicker from '../Date/index';
import Checkboxlayer from '../Input/checkBox';
import RadioButtonLayer from '../Input/radioButton';
const { Option } = Select;

class Add_more_table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'table_head': [], 'table_body': [], 'add_more': false, 'add_more_title': null
        }

        // excludesUpdateTableStore.subscribe(() => {
        //     this.updateTablebody();
        // })
    }

    componentDidMount() {
        let { table_head, table_body, add_more, add_more_title } = this.props.table_data;
        this.setState({ 'table_head': table_head, 'table_body': table_body, 'add_more': add_more, 'add_more_title': add_more_title })
    }
    componentDidUpdate(prevProps, prevState) {
        let { table_body } = this.state
        // console.log('update:', this.state.table_body.length, prevProps.table_data.table_body.length, this.props.table_data.table_body.length)
        if (prevProps.table_data.table_body.length > 0 !== this.state.table_body.length > 0) {
            // if (prevProps.table_data.table_body[0].feilds.length>0 && this.state.table_body[0].feilds.length>0) {
            //     if (prevProps.table_data.table_body[0].feilds[0].value !== this.state.table_body[0].feilds[0].value) {
            this.setState((state) => ({ 'table_body': this.props.table_data.table_body, }), () => {
                // this.props.table_body_change(this.props.table_data.table_body);
            })
            //     }
            // }
        }
    }

    updateTablebody() {
        let { table_from } = this.props;

    }

    handleChange(data) {
        let { name, id, value, selected_option } = data;


        this.props.change(data);

    }

    addButton() {
        let { table_from } = this.props;
        try {
            let add_more_feilds = this.props.table_data.add_more_feilds;
            let { table_body } = this.state;

            let last_element = table_body[table_body.length - 1];
            let last_id = (last_element && last_element['id']) ? last_element['id'] : 0;
            let add_more = JSON.parse(JSON.stringify(add_more_feilds));

            add_more.map((feild, key) => {
                add_more[key]['id'] = last_id + 1;
                add_more[key]['value'] = null;
                add_more[key]['text'] = null;
            })

            let obj = [{
                'id': last_id + 1,
                'key_word': 'add_more',
                text: "Highend", type: "text", input_feild: [],
                'feilds': add_more
            }]
            if (table_from !== 'excludes_schema') {
                this.props.change(obj);
                this.setState((state) => ({ 'table_body': state.table_body.concat(obj) }), () => {
                    let { table_body } = this.state;
                    console.log(table_body)
                })
            }
            // this.props.change(obj);
            if (table_from === 'excludes_schema') {
                this.setState((state) => ({ 'table_body': state.table_body.concat(obj) }), () => {
                    let { table_body } = this.state;
                    console.log(table_body)
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    deleteRow(row_id) {
        let table_body = this.state.table_body;
        let { table_from, form_table } = this.props;

        // if (row_id) {
        try {
            if (table_body.length > 1) {
                let removed_obj = table_body.splice(row_id, 1);
                if (table_from !== 'excludes_schema') {
                    this.props.deleteLineItem(removed_obj);
                }
            } else {
                if (row_id === 0 && form_table !== 'additional_packages' && form_table !== 'additional_procedures') {
                    table_body.map((body, key) => {

                        if (key === row_id && body['feilds']) {
                            body['feilds'].map((feild, feild_key) => {
                                if (feild.name === 'excludes_service_id') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'additional_surgery_procedure_name') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'additional_package_name') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'qty') {
                                    table_body[key]['feilds'][feild_key]['value'] = null
                                }
                                if (feild.name === 'rate') {
                                    table_body[key]['feilds'][feild_key]['value'] = null
                                }
                                if (feild.name === 'amount') {
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                }

                            })
                        }
                    })
                }

                if (row_id === 0 && (form_table === 'additional_packages' || form_table === 'additional_procedures' || form_table === 'ailment_capping' || form_table === 'interim' || form_table === 'previlage')) {
                    let removed_obj = table_body.splice(row_id, 1);
                    this.props.deleteLineItem(removed_obj);
                }
            }

            this.setState({ 'table_body': table_body }, () => {
                if (table_from === 'excludes_schema') {
                    let { table_body } = this.state;
                    // excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                }
            })


        } catch (error) {
            console.log(error);
        }
        // }
    }
    render() {
        let { table_head, table_body, add_more, add_more_title } = this.state;
        let { slug } = this.props.match.params;

        return (<table className="table table-hover table-bordered">
            <thead>
                <tr>
                    {table_head.map((head, hKey) => {
                        return (<td style={{ width: head.width }} key={hKey}>{head.text}</td>)
                    })}

                </tr>
            </thead>

            <tbody>

                {table_body.length > 0 && table_body.map((feild, key) => {
                    return (
                        <tr key={key}>
                            <td>{key + 1}</td>

                            {feild.feilds.map((input, inkey) => {
                                if (input.visible && input.element === 'input') {
                                    return (
                                        <React.Fragment key={key}>
                                            <td key={inkey}>
                                                <div className="row mx-0">
                                                    <div className="col px-0">
                                                        <InputNumberlayer {...this.props} {...this.state} selectdata={input} onInputChanges={this.handleChange.bind(this)} />
                                                        {input.errors.map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger"  style={{fontSize: '10px'}}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )
                                }
                                if (input.visible && input.element === 'select') {
                                    return (
                                        <React.Fragment key={key}>
                                            <td key={inkey}>
                                                <div className="row mx-0">
                                                    <div className="col px-0">
                                                        <Select2
                                                            selectdata={input}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this.handleChange.bind(this)} />
                                                        {input.errors.map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger"  style={{fontSize: '10px'}}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )
                                }
                                if (input.visible && input.element === 'datepicker') {
                                    return (
                                        <td key={inkey}>
                                            <Datepicker selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'checkbox') {
                                    return (
                                        <td key={inkey}>
                                            <Checkboxlayer selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'radio') {
                                    return <React.Fragment key={key}>
                                        <td key={inkey}>
                                            <div className="row mx-0">
                                                <div className="col px-0">{input.data.map((radio, key) => {
                                                    return (<div className="w-50 d-inline-flex  radio-button ">
                                                        <RadioButtonLayer selectdata={radio}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this.handleChange.bind(this)} />

                                                    </div>)
                                                })}
                                                    {input.errors.map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger"  style={{fontSize: '10px',bottom: '-14px'}}>{error.message}</small>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                        </td>
                                    </React.Fragment>
                                }
                                // if (input.visible && input.element === 'action') {
                                //     return (
                                //         <td key={inkey}>
                                //             <Tooltip placement="top" title='Remove'>
                                //                 <img src="/assets/images/icons/delete.png" alt="Remove" className="mr-2" onClick={this.deleteRow.bind(this, key)} />
                                //             </Tooltip>
                                //         </td>
                                //     )
                                // }
                                if (input.visible && input.element === 'text') {
                                    return (
                                        <td key={inkey} colSpan={input.colSpan}>
                                            {input.title}
                                        </td>
                                    )
                                }
                            })}

                        </tr>)


                })}
                {table_body.length == 0 && <tr><td colSpan={table_head.length}><Empty /></td></tr>}
                {(add_more) && <tr>
                    <td colSpan={table_head.length} className="text-right">
                        <button className="btn btn-success" onClick={() => this.addButton(this)}>{add_more_title}</button>
                    </td>
                </tr>
                }
            </tbody>
        </table>)
    }
}

export default Add_more_table;
